import { getApplications } from './states';

export const services = {
  getApplications,
};
